import React from "react";
import "./storefront.css";

const buildBrandingStyles = (branding) => ({
  "--storefront-primary": branding.primaryColor,
  "--storefront-secondary": branding.secondaryColor || "#f8fafc",
  "--storefront-font": branding.fontFamily || "Georgia, Times New Roman, serif",
});

const StorefrontShell = ({ config, children }) => {
  const styles = buildBrandingStyles(config.branding);
  const hasLogo = Boolean(config.branding?.logoUrl);

  return (
    <div className="storefront-shell" style={styles} data-tone={config.branding.tone}>
      <header className="storefront-header">
        <div className="storefront-brand">
          <div className="storefront-brand__lockup" data-has-logo={hasLogo ? "1" : "0"}>
            {hasLogo ? (
              <img
                className="storefront-brand__logo"
                src={config.branding.logoUrl}
                alt={`${config.displayName} logo`}
                loading="lazy"
                decoding="async"
              />
            ) : null}

            <div className="storefront-brand__text">
              <div className="storefront-brand__wordmark">{config.displayName}</div>
              {config.legalName ? (
                <div className="storefront-brand__legal">{config.legalName}</div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="storefront-brand__meta">
          <span className="storefront-brand__meta-label">Powered by</span>{" "}
          <strong className="storefront-brand__meta-brand">Reflectify</strong>
        </div>
      </header>

      {children}

      <footer className="storefront-footer">
        <p>{config.displayName} storefront hosted by Reflectify.</p>
        {config.legalName ? <p>Legal entity: {config.legalName}</p> : null}
      </footer>
    </div>
  );
};

export default StorefrontShell;
